const regions = [
  {
    label: "Тазобедренный сустав",
    value: "hip_joint",
  },
  {
    label: "Позвоночник",
    value: "spine",
  },
];

export default regions;
